import {
  getAccountableTeamFromSendoutSide,
  isSuperUser,
  isUserInAccountableTeam,
  isUserTeamDirector
} from 'features/sendouts/common/accountability';
import { COLLABORATOR_SCOPE } from 'features/sendouts/common/constants';
import { useUserContext } from 'providers/UserProvider';
import { userHasSomeRoles } from 'services/Authorization';
import { Roles } from 'UI/constants/roles';

export const useSendoutAccountability = (sendout = {}) => {
  const [currentUser] = useUserContext();

  const jobOrderTeam = getAccountableTeamFromSendoutSide({
    accountableId: sendout?.jobOrderAccountable?.id,
    coachId: sendout?.jo_accountable_coach_id,
    additionalRecruiters: sendout?.joborder?.additionalRecruiters
  });

  const candidateTeam = getAccountableTeamFromSendoutSide({
    accountableId: sendout?.candidateAccountable?.id,
    coachId: sendout?.ca_accountable_coach_id,
    additionalRecruiters: sendout?.candidate?.additionalRecruiters
  });

  const collaboratorScope = COLLABORATOR_SCOPE.PairedToAccountable;
  const isUserInJobOrderTeam = isUserInAccountableTeam({
    accountableTeam: jobOrderTeam,
    user: currentUser,
    collaboratorScope
  });
  const isUserInCandidateTeam = isUserInAccountableTeam({
    accountableTeam: candidateTeam,
    user: currentUser,
    collaboratorScope
  });

  const isUserSuperUser = isSuperUser(currentUser);
  const isUserOperations = userHasSomeRoles(currentUser, [Roles.Operations]);
  const isUserCandidateTeamDirector = isUserTeamDirector({
    accountableTeam: candidateTeam,
    user: currentUser
  });

  return {
    canEditSendout: isUserInJobOrderTeam || isUserInCandidateTeam || isUserSuperUser,
    canStartPlacement: isUserInJobOrderTeam || isUserCandidateTeamDirector || isUserOperations,
    canConvertSendover: isUserInJobOrderTeam || isUserSuperUser
  };
};
